<template>
    <div class="depoimentoItem">
        <div class="d-flex align-items-center mb-3">
            <strong class="inicial text-white mr-2" :style="{ backgroundColor: bg }">{{ name.charAt(0) }}</strong>
            <!-- <img :src="img" alt="Foto de {{ name }}" class="rounded-circle mr-3" width="50" height="50"> -->
            <div>
                <strong class="block">{{ name }}</strong>
                <Star v-for="n in stars" :key="n" color="#EDB71D" size="20px" />
            </div>
        </div>
        <p>{{ text }}</p>
    </div>
</template>

<script>
import Star from './Star.vue'
export default {
    props: {
        bg: {
            type: String,
            default: '#777'
        },
        name: {
            type: String,
            required: false
        },
        stars: {
            type: Number,
            required: false
        },
        text: {
            type: String,
            required: false
        }
    },
    components: {
        Star
    },
    data() {
        return{
            
        }
    }
}
</script>